export default __webpack_public_path__ + "static/media/colusa-mexican-tacos.24b2efe6.jpeg";